import React from "react";
import {
  Button,
  Col,
  Divider,
  List,
  message,
  Popconfirm,
  Row,
  Select,
  Spin,
  Tag,
  Tooltip,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import {
  APIResponseStatus,
  EntityStatus,
  rowLayout,
  colLayout,
} from "../../Constants/Constants";
import {
  convertServiceDependencyApiToList,
  convertServiceDependencyListToApi,
} from "../../Helpers/ServiceHelpers";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { apiCallback } from "../../ApiHandlers/Common";
import { selectFilterFunction } from "../../Constants/Utilities";
import { BreadCrumbs } from "../Common/BreadCrumbs";

class ServiceDependency extends React.Component {
  constructor(props) {
    super(props);
    console.log("ServiceDependency props", props);
    this.state = {
      dependenciesToAdd: [],
      serviceList: [],
      existingDependencies: [],
      addingDependency: false,
      fetchingDependency: false,
    };
  }

  componentDidMount() {
    this.fetchServiceDependencyList();
  }

  getServiceList = (existDependencies) => {
    const { serviceData, record } = this.props;
    const existingDependencies =
      existDependencies || this.state.existingDependencies;
    return serviceData.filter(
      (item) =>
        item.serviceId !== record.serviceId &&
        !existingDependencies.some((t) => t.serviceId === item.serviceId)
    );
  };

  fetchServiceDependencyList = () => {
    const {
      record: { key },
    } = this.props;
    this.setState({ fetchingDependency: true });
    console.log("fetchServiceDependencyList...", key);
    const errorCallback = () => {
      const serviceList = this.getServiceList();
      this.setState({ serviceList, fetchingDependency: false });
      message.error("Error fetching Service Dependency list");
    };
    try {
      this.props.serviceDependencyApi.getDependentServices(
        key,
        apiCallback({
          history: this.props.history,
          errorCallback,
          successCallback: (data) => {
            if (data.status === APIResponseStatus.fail) {
              message.error(
                "Error fetching Service Dependency list: " + data.info
              );
            } else {
              const existingDependencies =
                convertServiceDependencyApiToList(data);
              const serviceList = this.getServiceList(existingDependencies);
              this.setState({
                serviceList,
                fetchingDependency: false,
                existingDependencies,
              });
            }
          },
        })
      );
    } catch (error) {
      errorCallback();
    }
  };

  addServicesToList = (servicesToAdd) => {
    console.log("addServicesToList", servicesToAdd);
    const { existingDependencies } = this.state;
    const newExistingDependencies = existingDependencies.concat(servicesToAdd);
    const newServiceList = this.getServiceList(newExistingDependencies);
    this.setState({
      existingDependencies: newExistingDependencies,
      serviceList: newServiceList,
    });
  };
  removeServiceFromList = (service) => {
    console.log("removeServiceFromList", service);
    const { existingDependencies } = this.state;
    const newExistingDependencies = existingDependencies.filter(
      (item) => item.serviceId !== service.serviceId
    );
    this.setState({
      existingDependencies: newExistingDependencies,
      serviceList: this.getServiceList(newExistingDependencies),
    });
  };

  handleChange = (value) => {
    this.setState({ dependenciesToAdd: value });
  };

  onServiceDependencyAdd = () => {
    const {
      record: { key },
    } = this.props;
    const { dependenciesToAdd } = this.state;
    console.log("onServiceDependencyAdd", key, dependenciesToAdd);
    this.setState({ addingDependency: true });
    const errorCallback = (error) => {
      message.error("Error adding dependencies to Service");
      this.setState({ addingDependency: false });
    };
    try {
      const serviceData = convertServiceDependencyListToApi(dependenciesToAdd);
      console.log("onServiceDependencyAdd serviceData", serviceData);
      this.props.serviceDependencyApi.updateDependentServices(
        key,
        serviceData,
        apiCallback({
          history: this.props.history,
          errorCallback,
          successCallback: (data) => {
            if (data.status === APIResponseStatus.fail) {
              if (data.info === "Active-Service-Not-Found") {
                message.error("Error: Service is not active");
              } else {
                message.error("Error adding Dependency:" + data.info);
              }
              this.setState({ addingDependency: false });
            } else {
              message.success(`Dependencies added successfully`);
              this.setState({ addingDependency: false, dependenciesToAdd: [] });
              this.fetchServiceDependencyList();
            }
          },
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  onServiceDependencyRemove = (item) => {
    const {
      record: { key },
    } = this.props;
    console.log("onServiceDependencyRemove", key, item);
    this.removeServiceFromList(item);
    const errorCallback = (error) => {
      message.error(`Error removing Service Dependency ${item.name}`);
      this.addServicesToList([item]);
    };
    try {
      this.props.serviceDependencyApi.removeDependencyServices(
        key,
        item.serviceId,
        apiCallback({
          history: this.props.history,
          errorCallback,
          successCallback: () =>
            message.success(`Dependency ${item.name} removed successfully`),
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  render() {
    const { onActionClick, record, parentBread } = this.props;
    const {
      serviceList,
      existingDependencies,
      dependenciesToAdd,
      fetchingDependency,
      addingDependency,
    } = this.state;
    return (
      <div className="service-dependency-container">
        <div className="page-header-container">
          <BreadCrumbs
            headers={parentBread.concat(`Service Dependency`)}
            onParentActionClick={onActionClick(null, null)}
          />
        </div>
        <Divider className="divider" />
        <div className="page-parent-title-container">
          <label>Service Name: {record.name}</label>
          <div style={{ fontWeight: "normal", marginLeft: "10px" }}>
            <Tag
              color={record.status === EntityStatus.ACTIVE ? "green" : "red"}
            >
              {record.status}
            </Tag>
          </div>
        </div>
        <Spin
          spinning={addingDependency}
          tip="Adding dependencies, please wait..."
        >
          <Row {...rowLayout} style={{ marginTop: "10px" }}>
            <Col {...colLayout} className="display-flex-column">
              <label className="section-title">Add Dependent Service(s):</label>
              <Select
                mode="multiple"
                className="tagged-dropdown"
                loading={fetchingDependency}
                style={{ width: "90%", maxWidth: "300px" }}
                placeholder={"Select Service(s)"}
                value={dependenciesToAdd}
                onChange={this.handleChange}
                filterOption={selectFilterFunction}
              >
                {serviceList.map((item) => (
                  <Select.Option
                    key={item.serviceId}
                    title={item.name}
                    className="tagged-dropdown-options"
                    disabled={item.status === EntityStatus.INACTIVE}
                  >
                    {item.name}
                    <Tag
                      color={
                        item.status === EntityStatus.ACTIVE ? "green" : "red"
                      }
                    >
                      {item.status}
                    </Tag>
                  </Select.Option>
                ))}
              </Select>
              <Button
                type="primary"
                className="add-button"
                onClick={this.onServiceDependencyAdd}
              >
                Add
              </Button>
            </Col>
            <Col {...colLayout} className="display-flex-column">
              <label className="section-title header-label">
                Dependent Service List:
              </label>
              <List
                bordered
                className="data-list"
                loading={
                  fetchingDependency && { tip: "Loading Dependencies..." }
                }
                dataSource={existingDependencies}
                renderItem={(item) => (
                  <List.Item>
                    <div className="data-list-item">
                      {item.name}
                      <Tooltip title="Remove dependency">
                        <Popconfirm
                          okText="Yes"
                          cancelText="No"
                          title="Are you sure want to remove service?"
                          onConfirm={() => this.onServiceDependencyRemove(item)}
                        >
                          <CloseOutlined />
                        </Popconfirm>
                      </Tooltip>
                    </div>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceDependencyApi: state.apis.serviceDependencyApi,
});

const connectedServiceDependency = connect(mapStateToProps)(ServiceDependency);

export default withRouter(connectedServiceDependency);
